import { useMutationWithErrorHandling, usePost } from '@app/sdk';
import { CheckReportsResponse } from '../../RegularPaymentServiceClient';

export function useCheckReports() {
  const post = usePost(true, "rp");

  async function checkReports({ reportType }: { reportType: string }) {
    return await post<CheckReportsResponse>(
      `/api/proxy/rp/scheme-integration-service/debug/check-reports?reportType=${reportType}`,
      {}
    );
  }

  return useMutationWithErrorHandling({
    mutationFn: checkReports,
  });
}
